import { Link } from 'react-router';
import iotsIconWhiteSvg from '../assets/icons/iots-icon-white.svg';
import iotsIconSvg from '../assets/icons/iots-icon.svg';

const IotsHeaderLogo = ({
  variant = 'white',
  url = '/',
  title = 'Córas Iompair Ar Líne na nOileán',
  subtitle = 'Islands Online Transport System',
  disableLink = false,
}: {
  variant?: 'color' | 'white';
  url?: string;
  title?: string;
  subtitle?: string;
  disableLink?: boolean;
}) => {
  const Wrapper: React.ElementType = disableLink ? 'div' : Link;
  const wrapperProps = disableLink ? {} : { to: url };

  return (
    <Wrapper
      {...wrapperProps}
      className="min-h-[40px] inline-flex items-center"
    >
      <img src={variant === 'white' ? iotsIconWhiteSvg : iotsIconSvg} />
      <div
        className={`flex flex-col pl-2 ml-2 border-l whitespace-nowrap ${variant === 'white' ? 'border-l-white text-white' : 'border-l-iots-brand text-iots-brand'} text-xs leading-4`}
      >
        <div className="font-bold">{title}</div>
        <div>{subtitle}</div>
      </div>
    </Wrapper>
  );
};

export default IotsHeaderLogo;
